import React from "react";
import { hashString } from "../../utils/utils";
import { Container } from "../container";
import { LimaImage, getImageDataOrPublicURL } from "../lima-image";
import {
  getCookieConsentValue,
  resetCookieConsentValue,
} from "react-cookie-consent";
import { Button } from "../button";

export const Slider: React.FC<{
  items: (null | {
    id: string;
    image?: ImageDataLikeWithPropsForGifs | null;
    videoURL?: string | null;
    youtubeID?: string | null;
    vimeoID?: string | null;
    aspectRatio?: string | null;
    caption?: string | null;
  })[];
}> = ({ items, ...props }) => {
  return (
    <div {...props}>
      {items.map((item) => {
        if (!item) return null;
        const imageData = item.image
          ? getImageDataOrPublicURL(item.image)
          : null;
        // console.log({ image: item.image, imageData });
        const aspectRatioResults = item.aspectRatio
          ? /(\d+)\/(\d+)/.exec(item.aspectRatio)
          : null;
        const aspectRatio = aspectRatioResults
          ? parseInt(aspectRatioResults[1]) / parseInt(aspectRatioResults[2])
          : null;
        const columnSpan =
          aspectRatio === null
            ? "col-span-4 lg:col-span-3"
            : aspectRatio < 0.6
            ? "hidden lg:flex lg:col-span-1"
            : aspectRatio < 1.4
            ? "col-span-4 lg:col-span-2"
            : "col-span-4 lg:col-span-3";
        const aspectRatioClass =
          aspectRatio === null
            ? "aspect-video"
            : aspectRatio < 0.6
            ? "aspect-[9/16]"
            : aspectRatio < 1.4
            ? "aspect-square"
            : "aspect-video";
        return (
          <div key={item.id}>
            <Container className="mt-4 grid grid-cols-4 gap-16 lg:mt-12">
              {columnSpan === "col-span-4 lg:col-span-2" ||
                (columnSpan === "col-span-4 lg:col-span-3" &&
                  hashString(item.id) % 2 === 0 && (
                    <div className="hidden lg:col-span-1 lg:flex" />
                  ))}

              {columnSpan === "hidden lg:flex lg:col-span-1" && (
                <div className="col-span-4 lg:col-span-2" />
              )}

              <div className={columnSpan}>
                {imageData && <LimaImage image={imageData} alt="" />}
                {item.videoURL && (
                  <video
                    src={item.videoURL}
                    className="w-full"
                    autoPlay
                    muted
                    loop
                    controls
                  />
                )}
                {item.youtubeID &&
                  getCookieConsentValue("limaCookies") === "true" && (
                    <iframe
                      className={`w-full ${aspectRatioClass}`}
                      src={`https://www.youtube.com/embed/${item.youtubeID}?controls=1&loop=1`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  )}
                {item.vimeoID &&
                  getCookieConsentValue("limaCookies") === "true" && (
                    <>
                      <iframe
                        src={`https://player.vimeo.com/video/${item.vimeoID}?h=64e1a8aa84&loop=1&title=0&byline=0&portrait=0`}
                        className={`w-full ${aspectRatioClass}`}
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                      <script src="https://player.vimeo.com/api/player.js"></script>
                      {/* <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/159262422?h=64e1a8aa84&autoplay=1&loop=1&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script> */}
                    </>
                  )}
                {(item.youtubeID || item.vimeoID) &&
                  getCookieConsentValue("limaCookies") !== "true" && (
                    <div className="border-grey w-full border p-4">
                      You need to accept third-party cookies to see this
                      content.
                      <div className="pt-4">
                        <Button
                          className="inline-flex h-auto"
                          title="reset cookie permissions"
                          onClick={() => {
                            resetCookieConsentValue("limaCookies");
                            window.location.reload();
                          }}
                        />
                      </div>
                    </div>
                  )}
              </div>
            </Container>
            {item.caption && (
              <Container className="mt-2 grid grid-cols-4 gap-16">
                {columnSpan === "col-span-4 lg:col-span-2" ||
                  (columnSpan === "col-span-4 lg:col-span-3" &&
                    hashString(item.id) % 2 === 0 && (
                      <div className="hidden lg:col-span-1 lg:flex" />
                    ))}

                {columnSpan === "hidden lg:flex lg:col-span-1" && (
                  <div className="hidden lg:col-span-2 lg:flex" />
                )}

                <div className={columnSpan}>
                  <pre className="text-md text-right font-sans leading-tight text-beige">
                    {item.caption}
                  </pre>
                </div>
              </Container>
            )}
          </div>
        );
      })}
    </div>
  );
};
